import { z } from 'zod/v4'
import { AuthLoginFormField } from './auth'
import {
  BOOKING_STATUS,
  BUS_TRIP_TYPES,
  NOTIFICATION_CATEGORY,
} from '@/utils/constant'

export const AuthCheckYourInboxSearchSchema = AuthLoginFormField.pick({
  email: true,
})

export const AuthChangePasswordSearchSchema = z.object({
  reset_password_token: z.string().nonempty('Token is required'),
})

export const BaseRedirectSearchSchema = z.object({
  redirect: z.string().nonempty('Redirect is required'),
})

export const BaseAuthSearchSchema = BaseRedirectSearchSchema.pick({
  redirect: true,
}).partial({
  redirect: true,
})

export const PageWithRedirectSearchSchema = z.object({
  ...BaseAuthSearchSchema.pick({
    redirect: true,
  }).shape,
  tab: z.enum(BUS_TRIP_TYPES).optional(),
})

export const PaymentInfoSearchSchema = z.object({
  reference: z.string(),
  status: z.string(),
})

export const MyBookingListSearchSchema = z.object({
  tab: z.enum(BOOKING_STATUS).default(BOOKING_STATUS.DRAFT),
})

export const InboxPageSearchSchema = z.object({
  tab: z.enum(NOTIFICATION_CATEGORY).default(NOTIFICATION_CATEGORY.ALL),
})

export const BusDetailAddOnsSearchSchema = z.object({
  ...PageWithRedirectSearchSchema.shape,
  tab: z.enum(BUS_TRIP_TYPES).optional(),
})
